import { GET_CHECKOUT, GET_CHECKOUT_ERROR, GET_CHECKOUT_SUCCESS } from "core-web/state/models/Basket/constants";

import GetCheckout from "core-web/libs/GrebbCommerceAPI/Basket/GetCheckout";
import { acquireMutex } from "core-web/state";
import buildCheckoutResponse from "core-web/utils/buildCheckoutResponse";
import getBasketId from "core-web/state/models/Basket/utils/getBasketId";
import store from "core-web/state/store";
import validateMemberPromotions from "./validateMemberPromotions";

export const getCheckout =
    ({ isInitialFetch, overriddenBasketId } = {}) =>
    async (dispatch) => {
        const basketId = overriddenBasketId ? overriddenBasketId : await getBasketId();
        const mutexLock = await acquireMutex("basket.getBasket");

        dispatch({ type: GET_CHECKOUT });
        try {
            const response = await GetCheckout(basketId);
            const responseIsOk = await response.ok();
            if (!responseIsOk) {
                throw await response.status();
            }

            const responseBody = await response.body();
            const { checkoutResponse, basketItemsTree } = buildCheckoutResponse(responseBody);

            dispatch(Object.assign({ type: GET_CHECKOUT_SUCCESS, basketId }, checkoutResponse));

            mutexLock();

            if (isInitialFetch && checkoutResponse.activeMemberPromotions.length) {
                validateMemberPromotions(checkoutResponse.activeMemberPromotions.map(({ id }) => id));
            }

            return responseBody.data;
        } catch (e) {
            dispatch({ type: GET_CHECKOUT_ERROR });

            mutexLock();

            return { error: e };
        }
    };

export default ({ isInitialFetch, overriddenBasketId } = {}) =>
    store.dispatch(getCheckout({ isInitialFetch, overriddenBasketId }));
